// Every beat of the tv loop, in one place, in milliseconds.
//
//   bout ends ─ seal ─ the stage's fall and walk-off ─ new bout swapped in ─ the pair walk on, the salt ─ first turn streams
//
// The one duration the css shares is published as a custom property (see `publishTimings`).
export const T = {
  // the end
  READ_BEAT: 1400, // the last turn has typed: a beat to read it before the seal
  END_HOLD: 6200, // the fall and the bow take about this long; then we change channel the moment a bout is on (the stage's `basho:cleared` says when)
  NEXT_POLL: 1000, // while waiting for the next bout: how often we look (the server starts one ~5s after the last)
  END_FALLBACK: 25000, // no bout by then: go to a replay (a replay itself rolls on right at END_HOLD)
  SWITCH_FADE: 320, // main fades out, swaps, fades in

  // turns
  TYPE_CAP_LIVE: 14000, // a live turn never streams longer than this (a turn takes the model about as long); the next waits in line
  TYPE_CAP_BACKLOG: 5000, // one turn waiting: stream quick, but still a stream
  TYPE_CAP_REPLAY: 12000, // a replay: the same stream
  TURN_GAP: 250, // between a finished turn and the next / the thinking dots
  // a replay: the "thinking" pause before the next turn, from how much was just said
  REPLAY_THINK_MIN: 1800,
  REPLAY_THINK_MAX: 9000,
  REPLAY_THINK_BASE: 900,
  REPLAY_THINK_PER_WORD: 45,

  // a yokozuna is made: the tv lingers well past the usual hold
  CROWN_END_HOLD: 15000,

  // the opening: the words wait for the referee's wave (basho:hajime from the stage); this long at most, should it never come
  HAJIME_FALLBACK: 25000,

  // following the transcript
  FOLLOW_NUDGE: 250, // while a turn types, nudge into view this often
  FOLLOW_MARGIN: 72, // px above the window's bottom a turn must stay (the no-pane fallback)
  FOLLOW_DRAG: 8, // px of downward finger travel that counts as the reader taking over
  FOLLOW_STEP: 8, // px of extra scroll past the margin
  FOLLOW_BOTTOM: 40, // px from the pane bottom that counts as "at the bottom"

  // the stream
  STREAM_SILENCE: 120000, // a live stream quiet for this long is re-opened

  // a toast: a followed stable entered the ring
  TOAST: 8000,
};

/** Publish the duration the css animates with, once, on the root element. */
export function publishTimings(doc: Document) {
  const s = doc.documentElement.style;
  s.setProperty("--t-switch-fade", `${T.SWITCH_FADE}ms`);
}
